export default __webpack_public_path__ + "static/media/thats-me-btn-bg-4x.2b886900.png";